/** A `{{...}}` token as the Editor and profile show it. */
export type TokenChip = { tone: "name" | "meter" | "unknown"; label: string; value?: string; color?: string };
export type RenderTokenChip = (raw: string) => TokenChip;

export const TOKEN_CHIP_CLASS =
  "mx-px inline-flex items-center gap-[5px] whitespace-nowrap rounded-[6px] px-[7px] align-[1px] text-xs font-medium leading-5";
export const TOKEN_CHIP_VALUE_CLASS = "font-normal opacity-65";

const NAME_TINT = { background: "rgba(43,142,255,0.16)", border: "rgba(43,142,255,0.4)", color: "#9CC8FF" };
const UNKNOWN_TINT = { background: "rgba(245,165,36,0.12)", border: "rgba(245,165,36,0.5)", color: "#F5A524" };
const METER_BG_ALPHA = "33";
const METER_BORDER_ALPHA = "99";

export type TokenChipTint = { background: string; border: string; color: string };

export const getTokenChipTint = (chip: TokenChip): TokenChipTint => {
  if (chip.tone === "name") {
    return NAME_TINT;
  }
  if (chip.tone === "unknown" || !chip.color) {
    return chip.tone === "unknown" ? UNKNOWN_TINT : { background: "rgba(255,255,255,0.08)", border: "rgba(255,255,255,0.3)", color: "inherit" };
  }
  return { background: chip.color + METER_BG_ALPHA, border: chip.color + METER_BORDER_ALPHA, color: "inherit" };
};
